// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"SaveItemsButton_buttonContainer__2RMI5"};